import { graphql } from "relay-runtime"
import { useBetterDocMutation } from "@/modules/admin/better-doc/hooks/useBetterDocMutation"
import { useSimulateBetterDocPatientSelectionMutation as useSimulateBetterDocPatientSelectionMutationType } from "@/modules/admin/better-doc/services/__generated__/useSimulateBetterDocPatientSelectionMutation.graphql"

const mutation = graphql`
  mutation useSimulateBetterDocPatientSelectionMutation($input: De_simulateBetterDocPatientSelectionInput!) {
    de_simulateBetterDocPatientSelection(input: $input) {
      actionResult: de_BetterDocSessionActionResult {
        sessionId
        isSuccessful
        httpStatusCode
        betterDocState
        caseId
        errorReason
        exchangeId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useSimulateBetterDocPatientSelectionMutation = () => {
  return useBetterDocMutation<useSimulateBetterDocPatientSelectionMutationType>(mutation)
}
